<template>
    <div :class="cardClass">
        <template
            v-if="!isLoading"
        >
            <div class="RPSingleLineGraphCard__header-bar">
                <div class="RPSingleLineGraphCard__header">
                    <span class="RPSingleLineGraphCard__header-text">
                        <slot name="header">{{ header }}</slot>
                    </span>
                    <small class="RPSingleLineGraphCard__info">
                        <slot name="info">{{ headerInfo }}</slot>
                    </small>
                </div>
                <div class="RPSingleLineGraphCard__card-container">
                    <slot name="cards"></slot>
                </div>
                <span class="RPSingleLineGraphCard__growth-box"></span>
                <div class="RPSingleLineGraphCard__actions">
                    <slot name="action"></slot>
                </div>
            </div>
            <div class="RPSingleLineGraphCard__chart-container">
                <ApexCharts
                    :series="[graphData]"
                    :options="options"
                    height="100%"
                />
            </div>
        </template>
    </div>
</template>
<script>
import ApexCharts from 'vue-apexcharts';
import colors from 'style/_colors.scss';
import stat from 'status';
import statusBuilder from 'status/statusBuilder';

export default {
    name: 'RPSingleLineGraphCard',
    components: {
        ApexCharts
    },
    props: {
        header: {
            type: String,
            default: ''
        },
        headerInfo: {
            type: String,
            default: 'Info'
        },
        graphData: {
            type: Object,
            required: true,
        },
        lineColor: {
            type: String,
            default: colors.secondaryPurple200
        },
        status: {
            type: String,
            default: stat.STANDBY,
        }
    },
    data(){
        return {
            renderComponent: true,
        };
    },
    computed: {
        isLoading(){
            return this.status === stat.LOADING;
        },
        cardClass(){
            return statusBuilder('RPSingleLineGraphCard', this.status);
        },
        options(){
            return {
                chart: {
                    type: 'area',
                    animations: {
                        enabled: false,
                    },
                    toolbar: {
                        show: false
                    }
                },
                colors: [this.lineColor],
                xaxis: {
                    type: "datetime",
                    tooltip: {
                        enabled: false
                    }
                },
                dataLabels: {
                    enabled: false
                },
                markers: {
                    size: 4,
                    strokeWidth: 0,
                    strokeDashArray: 0,
                    shape: "circle",
                },
                stroke: {
                    width: 2,
                    curve: 'smooth'
                },
                tooltip: {
                    followCursor: true,
                    x: {
                        show: false
                    }
                },
                legend: {
                    show: false,
                }
            };
        }
    },
    watch: {
        options(newOpt, oldOpt){
            if(newOpt !== oldOpt){
                this.renderComponent = false;

                this.$nextTick(() => {
                    // Add the component back in
                    this.renderComponent = true;
                });
            }

        }
    }
};
</script>
<style lang="scss">
    .RPSingleLineGraphCard {
        position: relative;
        border-radius: 4px;
        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.08);
        padding: 1rem;
        background: $white;

        @include loading(100%, 100%);

        &__header-bar {
            display: flex;
            flex-direction: row;
        }
        &__header {
            height: fit-content;
            display: flex;
            flex-direction: column;
            &-text {
                margin-right: 1rem;
                margin-bottom: 0.25rem;
                font-weight: 600
            }
        }
        &__info {
            color: $text-grey
        }
        &__card-container {
            display: flex;
            align-items: center;
            margin-left: 1rem;
            & > * { margin-right: 1rem; }
        }
        &__growth-box {
            flex-grow: 1;
        }
        &__actions {
            height: fit-content;
        }
        &__chart-container {
            position:absolute;
            bottom: 1rem;
            top: 5rem;
            left: 1rem;
            right: 1rem;
        }
    }
</style>
